// Matches the collection-grid promo banner's height to its row's product cards.
// The grid is display:flex (not CSS grid), so nothing stretches items to a
// shared row height automatically - measure the actual siblings instead.
(function () {
  function syncHeight() {
    var banner = document.querySelector('.collection-promo-banner');
    if (!banner) return;
    var item = banner.closest('.grid__item');
    var siblings = Array.prototype.slice.call(item.parentElement.children);
    var rowTop = item.offsetTop;
    var rowMax = siblings.reduce(function (max, sibling) {
      if (sibling === item || Math.abs(sibling.offsetTop - rowTop) > 2) return max;
      return Math.max(max, sibling.offsetHeight);
    }, 0);
    banner.style.height = rowMax > 0 ? rowMax + 'px' : '';
  }

  var raf = null;
  function scheduleSync() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(syncHeight);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('load', scheduleSync);
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  // Filtering/sorting replaces #ProductGridContainer's innerHTML directly
  // (facets.js) without firing any load/section event, so the height fix
  // above never reran and the banner fell back to its square default until
  // a hard refresh. Watch the container itself instead of relying on events.
  function observeGridContainer() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(scheduleSync).observe(container, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', observeGridContainer);
})();
